import type { AcceptReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateReturnRequests from "./use-invalidate-return-requests";
import useInvalidateShop from "./use-invalidate-shop";

interface UseAcceptReturnRequestParams {
	onSuccess?: () => void;
	onMutate?: () => void;
	onError?: () => void;
	shopId: string;
}

export default function useAcceptReturnRequest(
	params: UseAcceptReturnRequestParams,
) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/accept",
		{
			invalidate: [
				useInvalidateShop(params.shopId),
				useInvalidateReturnRequests(),
			],
			onSuccess: params.onSuccess,
			onError: params.onError,
			onMutate: params.onMutate,
			mapVariables: ({
				variables,
				returnRequestId,
			}: {
				variables: AcceptReturnRequestDto;
				returnRequestId: string;
			}) => ({
				params: { path: { shopId: params.shopId, returnRequestId } },
				body: variables,
			}),
		},
	);
}
